import { render, staticRenderFns } from "./WerkplaatsenBase.vue?vue&type=template&id=7ffb6956&"
import script from "./WerkplaatsenBase.vue?vue&type=script&lang=js&"
export * from "./WerkplaatsenBase.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports